// Contact form: submits to Formspree by fetch, shows the result inline, and refuses
// submissions that arrive faster than a person could type.
export default function contact() {
    const form = document.querySelector("[data-contact-form]");
    if (!form) return;
    const started = Date.now();
    const status = form.querySelector(".gh-contact-status");
    const button = form.querySelector("button[type=submit]");
    form.querySelector("input[name=_started]").value = String(started);

    const say = (text, kind) => {
        status.textContent = text;
        status.className = `gh-contact-status is-${kind}`;
    };

    form.addEventListener("submit", async (e) => {
        e.preventDefault();
        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }
        if (form.querySelector("input[name=_gotcha]").value) return; // bot
        if (Date.now() - started < 3000) {
            say("That was quick. Give it a moment and try again.", "error");
            return;
        }
        button.classList.add("loading");
        button.disabled = true;
        try {
            const res = await fetch(form.action, {
                method: "POST",
                body: new FormData(form),
                headers: { Accept: "application/json" },
            });
            if (res.ok) {
                form.reset();
                say("Thanks. Your message is on its way, and I'll reply by email.", "success");
            } else {
                const data = await res.json().catch(() => ({}));
                say(data?.errors?.map((x) => x.message).join(" ") || "Something went wrong sending that. Try again in a minute.", "error");
            }
        } catch (err) {
            say("The message couldn't be sent. Check your connection and try again.", "error");
        } finally {
            button.classList.remove("loading");
            button.disabled = false;
        }
    });
}
